import { call, put } from 'redux-saga/effects';
import {
  fetchExcelFilesMetadataFailure,
  fetchExcelFilesMetadataSuccess,
} from '../actions';
import { getExcelFilesMetadata } from '../api';
import { ApiError } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { FetchExcelFilesMetadataRequestAction } from '../types';
import { MessageData } from 'store/app/types';
import { turnMessageOn } from 'store/app/actions';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* fetchExcelFilesMetadataSaga(
  action: FetchExcelFilesMetadataRequestAction
) {
  try {
    const { organisationId } = action.payload;

    const response = yield call(getExcelFilesMetadata, organisationId);

    const err: ApiError | null = checkResponse(response?.responseMessage);
    if (err) throw err;

    yield put(
      fetchExcelFilesMetadataSuccess(organisationId, response.data.files)
    );
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(fetchExcelFilesMetadataFailure());
  }
}
